module.exports = __webpack_public_path__ + "static/media/trade-opportunities-woman.208e7d04.png";